import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_LIST_PASSPORTS,
    REQUEST_ADD_PASSPORT,
    REQUEST_UPDATE_PASSPORT_WITH_OAUTH,
    REQUEST_UPDATE_PASSPORT,
    REQUEST_REMOVE_PASSPORT,
    REQUEST_BASE_URL,
    REQUEST_CODE_CHALLENGE,
    REQUEST_ACCESS_TOKEN,
    REQUEST_SHEET_NAMES,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/excelMsgDefinitions";
import {
    ExcelPassportHeader,
    ExcelPassportID,
    ExcelEmbedUrlRequest,
    ExcelSheetNamesRequest,
} from "userful-chronos-app-common-js/dist/models/integration/excel";
import "./excelMsgReciever";

export const requestListPassports = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSPORTS);
};

export const requestAddPassport = (payload: ExcelPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_PASSPORT, payload);
};

export const requestUpdatePassportWithOAuth = (payload: ExcelPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT_WITH_OAUTH, payload);
};

export const requestUpdatePassport = (payload: ExcelPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT, payload);
};

export const requestRemovePassport = (payload: ExcelPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSPORT, payload);
};

export const requestBaseURL = (payload: ExcelPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_BASE_URL, payload);
};

export const requestPreviewURL = (payload: ExcelEmbedUrlRequest) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_BASE_URL, payload);
};

export const requestCodeChallenge = (payload: ExcelPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_CODE_CHALLENGE, payload);
};

export const requestAccessToken = (payload: ExcelPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ACCESS_TOKEN, payload);
};

export const requestSheetNamesFromServer = (payload: ExcelSheetNamesRequest) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SHEET_NAMES, payload);
};
